// extracted by mini-css-extract-plugin
export default {"root":"p7ftT0uei1cMEOGLsKJw","label":"rGgaQUYzuXQiNHn1nP_Q"};